import { render, staticRenderFns } from "./ProductTags.vue?vue&type=template&id=e5403ab6"
import script from "./ProductTags.vue?vue&type=script&lang=js"
export * from "./ProductTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports